/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from 'react';
import { Formik } from "formik";
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from './contentCard';
import CheckBox from 'components/Form/CheckBox';
import { Row, Col } from 'components/Grid';
import { Label } from "components/Form";
import Icon from 'components/Icon';
import Colors from 'constants/Colors';
import MasksHelper from 'utils/src/masks';
import { useHistory } from 'react-router-dom';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import _, { upperCase } from 'lodash'
import { GridColumnTitle } from "components/Form";
import MessageExchangeEmail from 'components/MessageExchangeEmail';

import {
  ButtonContent,
  Text,
  Line,
  Scrollbox,
  InsurerName,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCollum,
  InlineLabel,
  LabelEdit,
} from './styles';
import Loader from 'components/Loader/index';
import { LostCancelButton } from 'components/index';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import { useHeaderNbi, useMarketsResponse } from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService'; 

export default function MarketManagement(props) {
  const [summary, setSummary] = useState({});
  const [masks, setMasks] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [productId, setProductId] = useState(null);
  const [isBound, setIsBound] = useState(false);
  const [idDomainStatusNBI, setIdDomainStatusNBI] = useState(null);
  const [insurer, setInsurer] = useState(null);
  const [facility, setFacility] = useState(null);
  const [insurersListResponse, setInsurersListResponse] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    insurers: [],
    facilities: [],
    currencies: [],
  })
  const [nbiRequestReponses, setNbiRequestReponses] = useState([]);
  const [showExchangeMessageModal, setShowExchangeMessageModal] = useState(false);
  const [isSelectedAll, setIsSelectedAll] = useState(false);

  const maskHelper = new MasksHelper();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const formik = useRef();
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const isClient = authContext.enumProfile === 1 ? true : false;

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useMarketsResponseData,
    loading: useMarketsResponseLoading,
    error: useMarketsResponseError,
    status: useMarketsResponseStatus,
    request: useMarketsResponseRequest,
  } = useMarketsResponse(props.match.params.idOperation);

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useMarketsResponseLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useMarketsResponseLoading]);

  const columns = [
    {
      title: "Insurer",
      value: "nmInsurer"
    },
    {
      title: "Facility",
      value: "facilityName"
    },
    {
      title: "Status",
      value: "interes"
    },
    {
      title: "Decline Reason",
      value: "declineReason"
    },
    {
      title: "Currency",
      value: "currency"
    },
    {
      title: "Max Limit Of Liability",
      value: "maxLimitOfLiability"
    },
    {
      title: "Line Size %",
      value: "percLineSize"
    },
    {
      title: "Line Size",
      value: "lineSize"
    },
    {
      title: "Premium Rate",
      value: "premiumRate"
    },
    {
      title: "Comm. Fee Rate",
      value: "commitmentFeeRateAsPercent"
    }
  ];

  fitinsur.setAuthToken(authContext.token);

  const getMasks = async () => {
    const t = await maskHelper.getMaskConfigs([69, 70], 295, authContext.token);
    setMasks(t);
  }

  function handleGetList(queryString) {
    useMarketsResponseRequest().then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }

        const dataNbiRequestReponses = data.ret_value?.nbiRequestReponses.sort((a, b) => String(a?.insurer?.nmInsurer).localeCompare(String(b?.insurer?.nmInsurer))) || []
        setInsurersListResponse(dataNbiRequestReponses);

        if (formik?.current) {
          formik.current.setValues({
            nbiRequestReponses: dataNbiRequestReponses,
          })
        }

        setNbiRequestReponses(dataNbiRequestReponses);
        setIdDomainStatusNBI(data.ret_value.idDomainStatusNBI)

        const insurersFilter = [];
        const facilitiesFilter = [];
        const currenciesFilter = [];

        dataNbiRequestReponses.map(response => {
          const insurerAlreadySelected = insurersFilter.some(insurer => insurer.value === response.insurer.idPersonInsurer)
          const facilityAlreadySelected = facilitiesFilter.some(facility => facility.value === response.idQuestionnaireAnswer)
          const currencyAlreadySelected = currenciesFilter.some(currency => currency.value === response.currency)

          if (!insurerAlreadySelected && response?.insurer) insurersFilter.push({
            personName: response.insurer.insurerFirstName,
            value: response.insurer.idPersonInsurer
          });

          if (!facilityAlreadySelected && response.idQuestionnaireAnswer) facilitiesFilter.push({
            label: response.facilityName,
            value: response.idQuestionnaireAnswer
          });

          if (!currencyAlreadySelected && response.currency) currenciesFilter.push({
            label: response.currency,
            value: response.currency
          });

        })

        setFilterOptions({
          insurers: insurersFilter,
          facilities: facilitiesFilter,
          currencies: currenciesFilter,
        })
      })
  };

  function handleFilter(filters) {
    const filtered = nbiRequestReponses
      .filter(response => {
        const insurer = filters.insurer
          ? response.insurer.idPersonInsurer === filters.insurer.value
          : true;

        const facility = filters.facility
          ? filters.facility.some(option => option === response.idQuestionnaireAnswer)
          : true

        const currency = filters.currency
          ? filters.currency.some(option => option === response.currency)
          : true

        const status = filters.status
          ? filters.status.some(option => option === response.interest)
          : true

        if (insurer && facility && currency && status) return response
      })
      .filter(Boolean)

    if (formik?.current) {
      formik.current.setValues({
        nbiRequestReponses: filtered,
      })
    }
  }

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          currency: data.ret_value.currency,
          idOperation: props.match.params.idOperation,
        });
        setEndorsmentType(data.ret_value.endorsmentType);
        setProductId(data.ret_value.idProduct);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
      });
  };

  function isSelected(response) {
    const isSelected = selectedItems.find((item) => response.insurer.idPersonInsurer === item.insurer.idPersonInsurer
      && response.idQuestionnaireAnswer === item.idQuestionnaireAnswer);
    return isSelected != null;
  }

  function handleSelect(response) {
    const alreadySelected = selectedItems.findIndex((item) => (response.insurer.idPersonInsurer === item.insurer.idPersonInsurer
      && response.idQuestionnaireAnswer === item.idQuestionnaireAnswer));

    if (alreadySelected !== -1) {
      const filteredItems = selectedItems.filter((_, i) => i !== alreadySelected);
      setSelectedItems(filteredItems);
      setIsSelectedAll(false)
    } else {
      setSelectedItems([
        ...selectedItems,
        response
      ]);
    }
  };

  function handleSelectAll(itens) {
    if (isSelectedAll) {
      setSelectedItems([])
      setIsSelectedAll(false)
    }
    else {
      const ableToSelect = itens.filter(itens => itens.interest === 'Indicated')
      setSelectedItems(ableToSelect);
      setIsSelectedAll(true)
    }
  };

  function testJSON(text) {
    if (typeof text !== "string") {
      return false;
    }
    try {
      JSON.parse(text);
      return true;
    }
    catch (error) {
      return false;
    }
  }

  function handleNbi() {
    loading.start();

    if (selectedItems.length === 0) {
      mc.error("Please, select at least one option.")
      loading.stop();
      return;
    } else {
      fitinsur.requestClientForm(
        props.match.params.idOperation,
        selectedItems.map((e) => ({
          idPersonInsurer: e.insurer.idPersonInsurer,
          facility: e.idQuestionnaireAnswer,
          legalEntities: e?.legalEntities?.map(legalEntity => legalEntity.idPersonLegalEntity) || []
        })))
        .then(a => {
          if (a.status !== 200) {
            a.json()
              .then(res => {
                mc.error(res.ret_msg_details);
                history.goBack();
                return;
              })
          } else {
            a.text()
              .then((response) => {

                if (testJSON(response)) {
                  response
                    .json()
                    .then(res => {
                      mc.error(res.ret_msg_details);
                      history.goBack();
                      return;
                    })
                } else {
                  history.push(`/broking/nbi-request-cv/${props.match.params.idOperation}`, { idProduct: props?.location?.state?.idProduct })
                }
              })
          }
        }).catch((error) => {
          mc.error(`There was an error while fetching your data: ${handleNbi.name}\n` + error);
          console.error('fitPostDocument - Error:', error);
        });


    }
  };

  function handleShowNbi() {
    history.push(`/broking/approval-nbi-cv/${props.match.params.idOperation}`, { idProduct: props.location.state.idProduct })
  }

  function formatMaxLimit(value) {
    if (!value) return ''

    let mask = maskHelper.getMaskConfig(masks, 69, authContext.region);
    if (mask) {
      mask.padFractionalZeros = true;
      return maskHelper.resolveMask(value, mask);
    }
  }

  const renderFlowClient = () => {
    const selectMarketsUrl = '/broking/select-markets';

    return (
      <HasPermission permission={!isBound}>
        <HasPermission permission={props.permissions.SELECT_MARKETS && idDomainStatusNBI !== 19}>
          <Button third style={{ marginLeft: "10px", marginTop: "5px" }} onClick={() => endorsmentType === 'declaration' || props.location.state?.idProduct === 16 || productId === 16
            ? history.push(`${selectMarketsUrl}/${props.match.params.idOperation}/${productId || props.location.state?.idProduct}`, { idProduct: productId || props.location?.state?.idProduct })
            : history.push(`${selectMarketsUrl}/${props.match.params.idOperation}`, { idProduct: props.location?.state?.idProduct })}>
            UPDATE MARKET
          </Button>
        </HasPermission>

        <HasPermission permission={props.permissions.MARKETS_SELECTION_GENERATE_NBI}>
          {idDomainStatusNBI === 19
            ? <Button
              primary
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleShowNbi()
              }}
              style={{ marginLeft: "10px", marginTop: "5px" }}
            >
              VIEW NBI
            </Button>
            : <Button
              primary
              style={{ marginLeft: "10px", marginTop: "5px" }}
              onClick={() => handleNbi()}
            >
              GENERATE NBI
            </Button>
          }
        </HasPermission>
      </HasPermission>
    )
  }

  const handleOperationInfo = () => {
    useOperationInfoRequest().then(({data}) => {
        setIsBound(data.isBound || false)
      })
  }


  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    getMasks();
    handleSummary();
    handleGetList();
    handleOperationInfo();
  }, []);

  const validationClientFlow = response => {
    if (isClient) return null;

    setShowExchangeMessageModal(true);
    setInsurer(response.insurer.idPersonInsurer);
    setFacility(response?.facilityName)
  }

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary?.nmObligor || "Broking name"}
      subtitle={summary?.dealCode || "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <Scrollbox>
        <BrokingSummary data={summary} />
        <ContentCard
          title={endorsmentType === 'market-changes'
            ? 'Risk & Market Changes / MARKET MANAGEMENT'
            : "MARKET MANAGEMENT"}
          info={{
            idOperation: props.match?.params?.idOperation || null,
            idProduct: props.location?.state?.idProduct || null
          }}
          filterOptions={filterOptions}
          handleFilter={handleFilter}
        >
          <Formik
            innerRef={formik}
            initialValues={{ nbiRequestReponses: [] }}
          >
            {({ values }) => {
              return (
                <>

                  <Table>
                    <TableHead>
                      <TableRow>
                        {columns.map((column) =>
                          <TableHeader>
                            <GridColumnTitle>
                              {upperCase(column.title)}

                            </GridColumnTitle>
                          </TableHeader>
                        )}
                        <TableHeader >
                          <GridColumnTitle>{`${upperCase('select all')}`}</GridColumnTitle>
                          <Label>
                            <CheckBox
                              type="checkbox"
                              disabled={idDomainStatusNBI === 19 || !props.permissions.MARKETS_SELECTION_ANSWER_AS_INSURER}
                              checked={isSelectedAll}
                              onChange={() => handleSelectAll(values.nbiRequestReponses)}
                            />
                          </Label>
                        </TableHeader>
                        <TableHeader >
                          <GridColumnTitle>{`${upperCase('Actions')}`}</GridColumnTitle>
                        </TableHeader>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {values.nbiRequestReponses.map((response, index) => {
                        const hoverText = response.legalEntities
                          ?.map(legalEntity => `${legalEntity.insured_legal_entity}\n`)
                          ?.join("")

                        return (
                          <TableRow key={index}>
                            <TableCollum>
                              <InlineLabel>
                                Insurer
                              </InlineLabel>
                              <InsurerName data-hover={hoverText}>{response?.insurer?.insurerFirstName}</InsurerName>
                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Facility
                              </InlineLabel>
                              <Text> {response?.facilityName}</Text>
                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Status
                              </InlineLabel>
                              <Text> {response?.interest}</Text>
                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Decline Reason
                              </InlineLabel>
                              <Text> {response?.declineReason}</Text>
                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Currency
                              </InlineLabel>
                              <Text> {response?.currency}</Text>
                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Max Limit Of Liability
                              </InlineLabel>
                              <Text> {formatMaxLimit(response?.maxLimitOfLiability)}</Text>
                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Line Size %
                              </InlineLabel>
                              <Text>{response?.interest === "Indicated" && maskHelper.resolveMask(response?.percLineSize, maskHelper.getPercentage(authContext.region, 5, "9999", "0", true))}</Text>

                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Line Size
                              </InlineLabel>
                              <Text>{response?.interest === "Indicated" && maskHelper.resolveMask(response?.lineSize, maskHelper.getMaskConfig(masks, 69, authContext.region, null, true))}</Text>

                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Premium Rate
                              </InlineLabel>
                              <Text>{response.interest === "Indicated" && maskHelper.resolveMask(response?.premiumRate, maskHelper.getPercentage(authContext.region, 5, "9999", "0", true))}</Text>

                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Comm. Fee Rate
                              </InlineLabel>
                              <Text>{response?.interest === "Indicated" && maskHelper.resolveMask(response?.commitmentFeeRate, maskHelper.getPercentage(authContext.region, 5, "9999", "0", true))}</Text>
                            </TableCollum>

                            <TableCollum>
                              <InlineLabel>
                                Selected
                              </InlineLabel>
                              <Row style={{ alignItems: 'center' }}>
                                <Label>
                                  <CheckBox
                                    type="checkbox"
                                    disabled={idDomainStatusNBI === 19 || response?.interest !== "Indicated" || !props.permissions.MARKETS_SELECTION_ANSWER_AS_INSURER}
                                    checked={isSelected(response)}
                                    onChange={() => handleSelect(response)}
                                  />
                                </Label>
                              </Row>
                            </TableCollum>
                            <TableCollum>
                              <InlineLabel>
                                Actions
                              </InlineLabel>
                              <Row style={{ alignItems: 'center' }}>
                                {/* <Label>
                                  <CheckBox
                                    type="checkbox"
                                    disabled={idDomainStatusNBI === 19 || response?.interest !== "Indicated" || !props.permissions.MARKETS_SELECTION_ANSWER_AS_INSURER}
                                    checked={isSelected(response)}
                                    onChange={() => handleSelect(response)}
                                  />
                                </Label> */}
                                <Label
                                  onClick={() => isClient || idDomainStatusNBI === 19 ? true : validationClientFlow(response)}
                                  style={{ cursor: isClient || idDomainStatusNBI === 19 ? 'not-allowed' : 'pointer' }}
                                >
                                  <Icon
                                    name='chat-grey'
                                    style={{ cursor: isClient || idDomainStatusNBI === 19 ? 'not-allowed' : "pointer" }}
                                    disabled={isClient || idDomainStatusNBI === 19 ? true : false}
                                  />
                                </Label>
                              </Row>
                            </TableCollum>
                            {insurer === response.insurer.idPersonInsurer && facility === response?.facilityName && showExchangeMessageModal && (
                              <MessageExchangeEmail
                                show={showExchangeMessageModal}
                                idOperation={props.match?.params?.idOperation}
                                idPersonInsurer={response.insurer.idPersonInsurer}
                                insurersResponseList={insurersListResponse}
                                referenceNumber={summary.dealCode}
                              >
                                <Text style={{ marginLeft: '20px', cursor: 'inherit', color: '#fff', fontSize: '18px' }}>{response?.insurer?.insurerFirstName}</Text>
                                <Icon name="close" style={{ padding: '0 0.7rem', cursor: 'pointer', position: 'absolute', right: 0 }} onClick={() => setShowExchangeMessageModal(false)} />
                              </MessageExchangeEmail>)}
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>



                  <ButtonContainer>
                    <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                    <HasPermission permission={!isBound}>
                      <RenderButtons idOperation={props.match?.params?.idOperation}>
                        <ButtonContent>
                          <div style={{ marginTop: "5px" }}>
                            <LostCancelButton idOperation={props.match.params.idOperation} />
                          </div>
                          {renderFlowClient()}
                        </ButtonContent>
                      </RenderButtons>
                    </HasPermission>
                  </ButtonContainer>
                </>
              )
            }}
          </Formik>
          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </ContentCard>
      </Scrollbox >
    </Layout >
  )
}
